import { Tag } from "@egaranti/components";

import { useTranslation } from "react-i18next";

import useCampaignsStore from "@/stores/useCampaignsStore";

import TrashIcon from "@/assets/icons/trash.svg?react";

const statusLabels = {
  PENDING: "applicationsPage.tabs.pending",
  APPROVED: "applicationsPage.tabs.approved",
  REJECTED: "applicationsPage.tabs.rejected",
  PROCESSED: "applicationsPage.tabs.processed",
};

const statusDefaults = {
  PENDING: "Bekleyen",
  APPROVED: "Onaylanan",
  REJECTED: "Reddedilen",
  PROCESSED: "İşlenen",
};

const ApplicationsFilterTags = () => {
  const { t } = useTranslation();
  const {
    applicationFilters: filters,
    validCampaigns,
    setApplicationFilters: setFilters,
    getApplications,
  } = useCampaignsStore();

  const campaignName = filters.campaignId
    ? validCampaigns.find((c) => String(c.id) === String(filters.campaignId))
        ?.name
    : null;

  return (
    <div className="flex h-full w-full items-center justify-start gap-4">
      {filters.status && filters.status !== "ALL" && (
        <Tag size="sm" className="flex items-center justify-center gap-2">
          {t(statusLabels[filters.status], statusDefaults[filters.status])}
          <TrashIcon
            className="h-3 w-3 cursor-pointer"
            onClick={() => {
              setFilters({ ...filters, status: "ALL" });
              getApplications();
            }}
          />
        </Tag>
      )}
      {filters.campaignId && campaignName && (
        <Tag size="sm" className="flex items-center justify-center gap-2">
          {campaignName}
          <TrashIcon
            className="h-3 w-3 cursor-pointer"
            onClick={() => {
              setFilters({ ...filters, campaignId: "" });
              getApplications();
            }}
          />
        </Tag>
      )}
    </div>
  );
};

export default ApplicationsFilterTags;
